var React = require('react');

function Suitcase (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(36 23)","stroke":"0","strokeWidth":"4","fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"y":"14","width":"36","height":"49","rx":"4.89","key":0}),React.createElement("path",{"d":"M8.5 21v36M18.5 21v36M27.5 21v36","key":1}),React.createElement("circle",{"cx":"29.5","cy":"66.5","r":"3.5","key":2}),React.createElement("circle",{"cx":"5.5","cy":"66.5","r":"3.5","key":3}),React.createElement("rect",{"x":"10","width":"17","height":"5","rx":"2.5","key":4}),React.createElement("path",{"d":"M12.5 5v10M23.5 5v10M36.048 32h3.256C40.794 32 42 33.104 42 34.466v9.068C42 44.896 40.793 46 39.304 46H36","key":5})]));
}

Suitcase.defaultProps = {"width":"114","height":"114"};

module.exports = Suitcase;

Suitcase.default = Suitcase;
